<script setup lang="ts">

import {ref} from 'vue';

function sendUrlToApi(url) {
    let queryParams = {
        source_url: url
    }

    let paramString = (new URLSearchParams(queryParams)).toString();

    fetch(`/api/redirects/redirect?${paramString}`, {
        method: 'GET',
    })
        .then(response => response.json())
        .then(data => {
            console.log(data);
            if (data.target_url) {
                targetUrl.value = data.target_url;
                bannerText.value = data.banner_text;
                autoRedirect.value = data.auto_redirect;
                redirectType.value = data.redirect_type;
            } else {
                error.value = true;
            }
        })
        .catch(error => {
            error.value = true;
        }).finally(() => {
        redirecting.value = true;
        if (autoRedirect.value) {
            setTimeout(() => {
                window.location.href = `https://${targetUrl.value}`;
            }, 10000);

            setInterval(() => {
                countdown.value++;
            }, 1000);
        }
    });
}

// Get the current URL
const currentUrl = ref(window.location.href);
const targetUrl = ref('emerge-db.asc.ohio-state.edu/');
const bannerText = ref('');
const redirectType = ref('');
const autoRedirect = ref(false);
const redirecting = ref(false);
const error = ref(false);
const countdown = ref(0);

sendUrlToApi(currentUrl.value);

</script>
<template>
    <div class="row justify-content-center">
        <div class="col-md-8">
            <div>
                <div class="alert alert-warning">
                    {{ bannerText }}
                </div>
                <template v-if="redirecting">
                    <div v-if="!error">
                        <div v-if="autoRedirect">
                            <p>Redirecting <a :href="currentUrl" class="d-block">{{ currentUrl }}</a> to <a
                                :href="`https://${targetUrl}`" class="d-block">https://{{ targetUrl }}</a> in 10
                                seconds. Click <a :href="`https://${targetUrl}`">here</a> to go there manually</p>
                        </div>
                        <div v-else-if="redirectType === 'path'">
                            <p><a :href="currentUrl" class="d-block">{{ currentUrl }}</a> is now <a
                                :href="`https://${targetUrl }`" class="d-block">https://{{ targetUrl }}</a>
                                Click
                                <a
                                    :href="`https://${targetUrl}`">here</a> to go the new location</p>
                        </div>
                        <div v-else-if="redirectType === 'domain'">
                            <p><a :href="currentUrl" class="d-block">{{ currentUrl }}</a> does not exist. The EMERGE-DB
                                homepage is: <a :href="`https://${targetUrl }`" class="d-block">https://{{
                                        targetUrl
                                    }}</a>
                                Click <a :href="`https://${targetUrl}`">here</a> to go the new location</p>
                        </div>

                    </div>
                    <div v-if="error">
                        <p>Couldn't find that URL or domain to redirect.
                            Click
                            <a
                                href="https://emerge-db.asc.ohio-state.edu" class="d-block">here</a> to go to the
                            EMERGE-DB homepage.
                        </p>
                    </div>
                    <div class="progress" role="progressbar" aria-label="Basic example"
                         aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar" :style="`width: ${10 * countdown}%`"></div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>